<template>
  <div>
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- ปุ่มเพื่ม -->
      <div class="btn-space">
        <b-button
          variant="primary"
          @click="openAdminForm"
        >
          {{ $t('AddFix') }}
        </b-button>
      </div>

      <!-- ค้นหาเลขซ่อม -->
      <div class="search-filters">
        <b-form-group :label="$t('searchorder')">
          <b-form-input
            v-model="search.order"
            :placeholder="$t('placeholderOrderFix')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchUser')">
          <b-form-input
            v-model="search.username"
            :placeholder="$t('user')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchworkername')">
          <b-form-input
            v-model="search.workername"
            :placeholder="$t('workername')"
          />
        </b-form-group>
		
		<b-form-group :label="$t('searchsn')">
          <b-form-input
            v-model="search.sn"
            :placeholder="$t('sn')"
          />
        </b-form-group>

        <b-form-group :label="$t('startDate')">
          <b-form-input
            v-model="search.startDate"
            type="date"
          />
        </b-form-group>

        <b-form-group :label="$t('endDate')">
          <b-form-input
            v-model="search.endDate"
            type="date"
          />
        </b-form-group>
        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchFixes(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>
      </div>

      <!-- ปุ่มแสดงสถานะ -->
      <div class="btn-space">
        <b-button
          :variant="buttonVariant"
          :disabled="!isButtonEnabled"
          :class="{ blinking: countWaiting > 0 }"
          @click="headApprovelButtonClick(0, 'waitingApprove')"
        >
          {{ $t('headcheck') }} <span v-if="countWaiting > 0">({{ countWaiting }})</span>
        </b-button>
        <b-button
          :variant="activeButton === 'fixstatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(1, 'fixstatus')"
        >
          {{ $t('fixstatus') }}
        </b-button>
        <b-button
          :variant="activeButton === 'fixing' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(2, 'fixing')"
        >
          {{ $t('fixing') }}
        </b-button>
        <b-button
          :variant="activeButton === 'claim' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(3, 'claim')"
        >
          {{ $t('claim') }}
        </b-button>
        <b-button
          :variant="activeButton === 'specialStatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(5, 'specialStatus')"
        >
          {{ $t('cancelSucc') }}
        </b-button>
      </div>
      <!-- ตารางซ่อม -->
      <div class="table-wrapper">
        <b-table
          v-if="!isLoading && totalFixes > 0"
          :items="fixes"
          :fields="fields"
          class="fix-table"
        >
          <template #cell(order)="data">
            {{ data.item.order || '' }}
          </template>
          <template #cell(timefix)="data">
            {{ new Date(data.item.timefix).toLocaleString('th-TH', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }) || '' }}
          </template>

          <template #cell(category)="data">
            {{ data.item.category.nameCate || '' }}

          </template>
          <template #cell(subcategory)="data">
            {{ data.item.subcategory.name || '' }}
          </template>
          <template #cell(location)="data">
            {{ data.item.location ? data.item.location.locationName : '' }}
          </template>

          <template #cell(devicecategory)="data">
            {{ data.item.deviceCategory ? data.item.deviceCategory.name : '' }}

          </template>
          <template #cell(devicesubcategory)="data">
            {{ data.item.deviceSubcategory ? data.item.deviceSubcategory.name : '' }}

          </template>
          <template #cell(user)="data">
            <b-button
              variant="link"
              @click="showEmployeeModal(data.item.user.id)"
            >
              {{ data.item.user.username || '' }}

            </b-button>
          </template>

          <template #cell(status)="data">
            {{ data.item.status && data.item.status.statusName ? data.item.status.statusName : '' }}
          </template>

          <template #cell(actions)="data">
            <b-button
              class="b-btn"
              variant="primary"
              size="sm"
              @click="viewDetails(data.item)"
            >
              {{ $t('details') }}
            </b-button>

            <template v-if="data.item && data.item.status && ![1, 4, 5].includes(data.item.status.id)">
              <b-button
                class="b-btn"
                variant="warning"
                size="sm"
                @click="editFix(data.item)"
              >
                {{ $t('edit') }}
              </b-button>
            </template>
          </template>
        </b-table>
        <div
          v-if="!isLoading && totalFixes === 0"
          class="text-center mt-3"
        >
          <p style="font-size: 28px; font-weight: bold;">
            {{ $t('nofix') }}
          </p>
        </div>
      </div>

      <!-- Default -->
      <div
        v-if="!isLoading && !isSearchActive && !isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'normal'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>

      <!-- Search -->
      <div
        v-if="!isLoading && isSearchActive && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'search'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangesearch"
        />
      </div>

      <!-- Waiting Approve -->
      <div
        v-if="!isLoading && isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'waiting'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangewaitingApprove"
        />
      </div>

      <!-- model ซ่อม -->

      <div
        v-if="loadingfix"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>

      <b-modal
        v-model="showRepairForm"
        :title="$t('fixedit')"
        class="custom-modal"
        size="xl"
        hide-footer
        :disabled="loadingfix"
        @hidden="clearSelectedFix"
      >
        <AdminForm
          :fix="selectedFix"
          :categories="categories"
          :devicecategories="devicecategories"
          :devices="Object.values(devices)"
          :users="users"
          :loading="loadingfix"
          :locations="locations"
          @fix-saved="handleFixSaved"
          @close="showRepairForm = false"
        />
      </b-modal>

      <!-- model รายละเอียด -->
      <div
        v-if="isLoadingViewDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>

      <DetailsModal
        v-if="!isLoadingViewDetails"
        :show="showDetailsModal"
        :expense="expense"
        :fix="selectedFix"
        :spare-list="spareList"
        @close="showDetailsModal = false"
        @refresh="handleRefresh"
      />

      <!--model user-->
      <EmployeeModal
        :show="modalShowfix"
        :employee="selectedEmployee"
        @close="modalShowfix = false"
      />

      <!--model device-->
      <div
        v-if="isLoadingDeviceDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>

      <DeviceModel
        v-if="localShowModal"
        :local-show-modal="localShowModal"
        :warranty="warrantyData"
        :hardware="deviceHardwareList"
        :fixhistory="fixhistoryList"
        :expensefix="expensefixList"
        :spare="SpareList"
        :devicehistory="devicehistoryList"
        :pmhistory="pmhistoryList"
        :details="selectedDevice || {}"
        @update:localShowModal="updateLocalShowModal"
        @close="handleCloseModal"
      />

      <!-- Device Form Modal -->
      <b-modal
        v-model="showForm"
        :title="$t('deviceedit')"
        size="lg"
        hide-footer
      >
        <DeviceForm
          :device="selectedDevice"
          :categories="categories"
          :users="users"
          @close="showForm = false"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import apiAdmin from '@/services/admin'
import apiSetting from '@/services/Setting'
import apiMst from '@/services/masterDate'
import apiAuth from '@/services/auth'
import { getRolesFromToken } from '@/services/JwtDecoder'
import AdminForm from './AdminForm.vue'
import DetailsModal from './DetailsModal.vue'
import EmployeeModal from './EmployeeModel_fix.vue'
import DeviceModel from '../MasterData/DeviceModel.vue'

export default {
  components: {
    AdminForm,
    DetailsModal,
    EmployeeModal,
    DeviceModel,
  },
  data() {
    return {
      fixes: [],
      filteredFixes: [],
      categories: [],
      devicecategories: [],
      users: [],
      devices: [],
      search: {
        order: '',
        username: '',
        workername: '',
        startDate: '',
        endDate: '',
		sn: '',
      },
      isLoading: true,
      activeButton: 'fixstatus',
      isButtonEnabled: true,
      showForm: false,
      showRepairForm: false,
      showDetailsModal: false,
      selectedFix: null,
      imageUrls: [],
      spareList: [],
      expense: [],
      errorMessage: '',
      localShowModal: false,
      selectedDevice: {},
      warrantyData: [],
      deviceHardwareList: [],
      pmhistoryList: [],
      roles: [],
      modalShowfix: false,
      modalShowdevice: false,
      selectedEmployee: {},
      currentPage: 1,
      itemsPerPage: 5,
      selectedStatusId: 1,
      totalFixes: 0,
      totalPages: 0,
      isLoadingViewDetails: false,
      loadingfix: false,
      isLoadingDeviceDetails: false,
      fixhistoryList: [],
      expensefixList: [],
      SpareList: [],
      devicehistoryList: [],
      isSearchActive: false,
      isWaitingApprove: false,
      showConfirmationModal: false,
      locations: [],
      countWaiting: 0,
    }
  },
  computed: {
    fields() {
      return [
        { key: 'order', label: this.$t('placeholderOrderFix'), sortable: true },
        { key: 'timefix', label: this.$t('fixDate'), sortable: true },
        { key: 'category', label: this.$t('cate'), sortable: true },
        { key: 'subcategory', label: this.$t('subcate'), sortable: true },
        { key: 'location', label: this.$t('locationname'), sortable: true },
		{
          key: 'sn', label: this.$t('sn'), sortable: true, thClass: 'text-center',
        },
        { key: 'user', label: this.$t('user'), sortable: true },
        /* { key: 'fixDetails', label: this.$t('fixDetails'), sortable: true },
        { key: 'fixDetailsAdditional', label: this.$t('problem'), sortable: true },
        { key: 'operator', label: this.$t('operator'), sortable: true }, */
        { key: 'status', label: this.$t('status'), sortable: true },
        { key: 'actions', label: this.$t('management') },
      ]
    },
    buttonVariant() {
      if (this.activeButton === 'waitingApprove') {
        return 'primary'
      } if (this.countWaiting > 0) {
        return 'warning'
      }
      return 'secondary'
    },
  },

  async mounted() {
    const queryId = Number(this.$store.getters.userId)
    this.activeButton = queryId === 414 ? 'waitingApprove' : 'fixstatus'
    this.fetchCountwaitingApprove()

    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
    this.dept = JSON.parse(localStorage.getItem('dept'))
    this.orderId = this.$route.params.orderId
    if (this.orderId) {
      this.ShowbyOrder()
    } else {
      await this.loadData()
    }
  },

  methods: {
    async loadData() {
      if (parseInt(this.$store.getters.userId, 10) === 414) {
        await this.fetchFixesheadApprove()
        await Promise.all([
          this.fetchCategories(),
          this.fetchDeviceCategories(),
          this.fetchLocations(),
          this.fetchUsers(),
        ])
      } else {
        await Promise.all([
          this.fetchFixes(),
          this.fetchCategories(),
          this.fetchDeviceCategories(),
          this.fetchLocations(),
          this.fetchUsers(),
        ])
      }
    },

    handleError(message, error) {
      console.error(message, error)
      this.errorMessage = message
    },

    setActive(buttonName) {
      this.activeButton = buttonName
    },

    async showDeviceModal(deviceId) {
      console.log('Device ID sent to API:', deviceId)

      this.isLoadingDeviceDetails = true

      try {
        const [response, hardwareResponse, warrantyResponse, fixhistoryRes, expenseHisRes, deviceHistoryRes, spareListRes, pmhistoryRes] = await Promise.allSettled([
          apiMst.get(`/deviceListId/${deviceId}`),
          apiMst.get(`/devicehardwareByDeviceId/${deviceId}`),
          apiMst.get(`/warrantyByDeviceId/${deviceId}`),
          apiAdmin.get(`/fixgetdevice/${deviceId}`),
          apiAdmin.get(`/expensefixList/device/${deviceId}`),
          apiAdmin.get(`/deviceUseHistoryGet/${deviceId}`),
          apiAdmin.get(`/sparelistByDevice/${deviceId}`),
          apiAuth.get(`/calendar/getdeviceCalendar?deviceId=${deviceId}`),
        ])

        // ดึงข้อมูลจากผลลัพธ์
        this.selectedDevice = response.status === 'fulfilled' ? response.value.data : {}
        this.deviceHardwareList = hardwareResponse.status === 'fulfilled' ? hardwareResponse.value.data || [] : []
        this.warrantyData = warrantyResponse.status === 'fulfilled' ? warrantyResponse.value.data || [] : []
        this.fixhistoryList = fixhistoryRes.status === 'fulfilled' ? fixhistoryRes.value.data || [] : []
        this.expensefixList = expenseHisRes.status === 'fulfilled' ? expenseHisRes.value.data || [] : []
        this.devicehistoryList = deviceHistoryRes.status === 'fulfilled' ? deviceHistoryRes.value.data || [] : []
        this.pmhistoryList = pmhistoryRes.status === 'fulfilled' ? pmhistoryRes.value.data || [] : []

        if (spareListRes.status === 'fulfilled') {
          const spareData = Array.isArray(spareListRes.value.data) ? spareListRes.value.data : []
          this.SpareList = spareData.map((spare, index) => ({
            id: spare.id,
            orderlist: index + 1,
            list: spare.spList || '',
            purchase: spare.spPurchase || '',
            quantity: spare.spQuantity || '',
            cost: spare.spCost || 0,
            source: spare.spSource || '',
            detail: spare.spDetail || '',
          }))
        } else {
          this.SpareList = []
        }

        this.$nextTick(() => {
          this.localShowModal = true
        })
      } catch (error) {
        console.error('Error fetching device details:', error)
      } finally {
        this.isLoadingDeviceDetails = false
      }
    },

    handleButtonClick(statusId, buttonType) {
      this.isWaitingApprove = false
      this.selectedStatusId = statusId
      this.activeButton = buttonType
      this.currentPage = 1
      this.fetchFixes()
      this.fetchCountwaitingApprove()
    },

    headApprovelButtonClick(statusId, buttonType) {
      this.selectedStatusId = statusId
      this.activeButton = buttonType
      this.currentPage = 1
      this.fetchFixesheadApprove()
      this.fetchCountwaitingApprove()
    },

    async searchFixes(page = 1) {
      this.isLoading = true
      this.isWaitingApprove = false
      try {
        if (!this.search.order && !this.search.username && !this.search.workername && !this.search.sn && !this.search.startDate && !this.search.endDate) {
          if (this.fixes.length === 0 || page === 1) {
            this.isSearchActive = false
            this.selectedStatusId = 1
            this.activeButton = this.getButtonType(1)
            this.currentPage = 1
            await this.fetchFixes(1)
            return
          }
        }
        this.isSearchActive = true
        this.currentPage = page

        const params = {
          order: this.search.order,
          username: this.search.username,
          workerUsername: this.search.workername,
		  sn: this.search.sn || null,
          startDate: this.search.startDate,
          endDate: this.search.endDate,
          page: page - 1,
          size: this.itemsPerPage,
        }

        let response

        // ตรวจสอบบทบาทผู้ใช้
        if (this.roles.includes('ADMIN') || this.roles.includes('SYSTEM')) {
          response = await apiAdmin.get('/fix/search', { params })
        } else {
          response = await apiAdmin.get(`/fixgetuserId/${this.$store.getters.userId}`, { params })
        }

        this.fixes = await Promise.all(response.data.content.map(async fix => {
          const showEvaluationButton = await this.checkSurveyStatus(fix.id)
          const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
          const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
          const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
          return {
            ...fix,
            showEvaluationButton,
            fixDetails: detailsResponse.data || [],
            fixDetailsAdditional: additionalResponse.data || [],
            fixsolution: solutionResponse.data || [],
          }
        }))
        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        // หากค้นหาแล้วไม่มีข้อมูล
        if (this.totalFixes === 0) {
          this.errorMessage = 'ไม่พบข้อมูลที่ค้นหา'
          this.currentPage = 1
          page = 1
        } else {
          this.errorMessage = ''
        }

        this.activeButton = null
      } catch (error) {
        console.error('Error fetching fixes:', error)
        this.fixes = []
        this.totalFixes = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
      }
    },

    async ShowbyOrder(page = 1) {
      this.isLoading = true
      try {
        this.isSearchActive = false
        this.activeButton = null
        this.currentPage = page

        const response = await apiAdmin.get(`/fix/search?order=${this.orderId}&page=0&size=5`)

        if (response.data.content.length === 0) {
          this.errorMessage = 'ไม่พบข้อมูลใบแจ้งซ่อมนี้'
          this.fixes = []
          this.totalFixes = 0
          this.totalPages = 0
          return
        }

        this.fixes = await Promise.all(response.data.content.map(async fix => {
          try {
            const [detailsResponse, additionalResponse, solutionResponse, showEvaluationButton] = await Promise.all([
              apiAdmin.get(`/details/${fix.id}`),
              apiAdmin.get(`/fixdetails/${fix.id}`),
              apiAdmin.get(`/fixsolution/${fix.id}`),
              this.checkSurveyStatus(fix.id),
            ])

            return {
              ...fix,
              fixDetails: detailsResponse.data || [],
              fixDetailsAdditional: additionalResponse.data || [],
              fixsolution: solutionResponse.data || [],
              showEvaluationButton,
            }
          } catch (error) {
            console.error(`Error fetching details for fix ${fix.id}:`, error)
            return {
              ...fix,
              fixDetails: [],
              fixDetailsAdditional: [],
              fixsolution: [],
              showEvaluationButton: false,
            }
          }
        }))

        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        this.errorMessage = `แสดงรายละเอียดใบแจ้งซ่อมหมายเลข: ${this.orderId}`
      } catch (error) {
        console.error('Error fetching fixes by order:', error)
        this.errorMessage = 'เกิดข้อผิดพลาดในการดึงข้อมูลใบแจ้งซ่อม'
        this.fixes = []
        this.totalFixes = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
      }
    },

    async checkSurveyStatus(fixId) {
      try {
        const response = await apiAdmin.get(`/checkSurvey/${fixId}`)
        return response.data
      } catch (error) {
        console.error('Error checking survey status:', error)
        return false
      }
    },

    handleShowModal(deviceDetails) {
      this.deviceDetails = deviceDetails.details
      this.deviceWarranty = deviceDetails.warranty
      this.deviceHardware = deviceDetails.hardware
      this.localShowModal = true
    },
    handleCloseModal() {
      this.localShowModal = false
      this.selectedDevice = {}
    },
    updateLocalShowModal(newVal) {
      this.localShowModal = newVal
    },

    async fetchFixes() {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const params = {
          statusId: this.selectedStatusId,
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        const response = await apiAdmin.get('/fix', { params })

        // ตรวจสอบสถานะและข้อมูลที่ได้
        if (response.status === 200 && Array.isArray(response.data.content)) {
          this.fixes = await Promise.all(response.data.content.map(async fix => {
            try {
              const [detailsResponse, additionalResponse, expenseResponse, fixsolutionResponse, sparelistResponse, showEvaluationButton] = await Promise.all([
                apiAdmin.get(`/details/${fix.id}`),
                apiAdmin.get(`/fixdetails/${fix.id}`),
                apiAdmin.get(`/expensefixList/${fix.id}`),
                apiAdmin.get(`/fixsolution/${fix.id}`),
                apiAdmin.get(`/sparelistByFixId/${fix.id}`),
                this.checkSurveyStatus(fix.id),
              ])

              return {
                ...fix,
                fixDetails: detailsResponse.data || [],
                fixDetailsAdditional: additionalResponse.data || [],
                fixsolution: fixsolutionResponse.data || [],
                expense: expenseResponse.data || [],
                spare: sparelistResponse.data || [],
                showEvaluationButton,
              }
            } catch (error) {
              console.error(`Error fetching details for fix ${fix.id}:`, error)
              return {
                ...fix,
                fixDetails: [],
                fixDetailsAdditional: [],
                fixsolution: [],
                expense: [],
                spare: [],
                showEvaluationButton: [],
              }
            }
          }))
          // อัปเดตข้อมูลจำนวนทั้งหมดและจำนวนหน้า
          this.totalFixes = response.data.totalElements
          this.totalPages = response.data.totalPages
        } else {
          this.fixes = []
        }
      } catch (error) {
        this.errorMessage = `ไม่สามารถโหลดข้อมูลการซ่อมได้: ${error.message}`
        console.error(error)
      } finally {
        this.isLoading = false
        this.localShowModal = false
      }
    },

    async fetchFixesheadApprove() {
      this.isLoading = true
      this.errorMessage = ''
      this.isWaitingApprove = true

      try {
        const params = {
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        const response = await apiAdmin.get('/Checker', { params })

        // ตรวจสอบสถานะและข้อมูลที่ได้
        if (response.status === 200 && Array.isArray(response.data.content)) {
          this.fixes = await Promise.all(response.data.content.map(async fix => {
            try {
              const [detailsResponse, additionalResponse, expenseResponse, fixsolutionResponse, sparelistResponse, showEvaluationButton] = await Promise.all([
                apiAdmin.get(`/details/${fix.id}`),
                apiAdmin.get(`/fixdetails/${fix.id}`),
                apiAdmin.get(`/expensefixList/${fix.id}`),
                apiAdmin.get(`/fixsolution/${fix.id}`),
                apiAdmin.get(`/sparelistByFixId/${fix.id}`),
                this.checkSurveyStatus(fix.id),
              ])

              return {
                ...fix,
                fixDetails: detailsResponse.data || [],
                fixDetailsAdditional: additionalResponse.data || [],
                fixsolution: fixsolutionResponse.data || [],
                expense: expenseResponse.data || [],
                spare: sparelistResponse.data || [],
                showEvaluationButton,
              }
            } catch (error) {
              console.error(`Error fetching details for fix ${fix.id}:`, error)
              return {
                ...fix,
                fixDetails: [],
                fixDetailsAdditional: [],
                fixsolution: [],
                expense: [],
                spare: [],
                showEvaluationButton: [],
              }
            }
          }))
          // อัปเดตข้อมูลจำนวนทั้งหมดและจำนวนหน้า
          this.totalFixes = response.data.totalElements
          this.totalPages = response.data.totalPages
        } else {
          this.fixes = []
        }
      } catch (error) {
        this.errorMessage = `ไม่สามารถโหลดข้อมูลการซ่อมได้: ${error.message}`
        console.error(error)
      } finally {
        this.isLoading = false
        this.localShowModal = false
      }
    },

    async showEmployeeModal(userId) {
      try {
        const response = await apiAuth.get(`auth/showbyid/${userId}`)
        console.log(response)
        this.selectedEmployee = response.data
        this.modalShowfix = true
      } catch (error) {
        console.error('Error fetching employee data:', error)
      }
    },

    async fetchLocations() {
      try {
        const response = await apiMst.get('/location')
        this.locations = response.data || []
      } catch (error) {
        console.error('Error fetching locations:', error)
      }
    },

    async handlePageChange(page) {
      this.currentPage = page
      await this.fetchFixes(this.currentPage)
    },

    async handlePageChangesearch(page) {
      this.currentPage = page
      await this.searchFixes(this.currentPage)
    },

    async handlePageChangewaitingApprove(page) {
      this.currentPage = page
      await this.fetchFixesheadApprove(this.currentPage)
    },

    refreshFixes(statusId) {
      this.selectedStatusId = statusId
      this.activeButton = this.getButtonType(statusId)
      this.currentPage = 1
      this.fetchFixes()
    },

    getButtonType(statusId) {
      switch (statusId) {
        case 0: return 'waitingApprove'
        case 1: return 'fixstatus'
        case 2: return 'fixing'
        case 3: return 'claim'
        case 4:
        case 5: return 'specialStatus'
        default: return null
      }
    },

    processFixes(data) {
      return Array.isArray(data) ? data.map(fix => ({
        ...fix,
        device: fix.device || { deviceName: '' },

      })) : []
    },

    async fetchCategories() {
      try {
        const response = await apiSetting.get('/cate')
        this.categories = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ได้'
      }
    },

    async fetchDeviceCategories() {
      try {
        const response = await apiMst.get('/device')
        this.devicecategories = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ได้'
      }
    },

    async fetchDevices() {
      try {
        const response = await apiMst.get('/deviceListAll')
        this.devices = response.data.content || []
        console.log('Devices loaded:', this.devices)
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดอุปกรณ์ได้'
      }
    },

    async fetchUsers() {
      try {
        const response = await apiAuth.get('/auth/showdata')
        this.users = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้'
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString('th-TH', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }) || ''
    },

    async deleteFix(id) {
      try {
        await apiAdmin.delete(`/fixDel/${id}`)
        this.fetchFixes()
      } catch (error) {
        this.handleError('ไม่สามารถลบข้อมูลการซ่อมได้', error)
      }
    },

    editFix(fix) {
      this.selectedFix = {
        ...fix,
      }
      this.showRepairForm = true
    },

    async openAdminForm() {
      if (this.loadingfix) {
        console.log('ยังไม่โหลดเสร็จ')
        return
      }
      if (this.users.length === 0) {
        this.loadingfix = true
        try {
          await this.fetchUsers()
        } catch (error) {
          console.error('Error fetching users:', error)
        } finally {
          this.loadingfix = false
        }
      }

      // กำหนดค่าของ selectedFix
      this.selectedFix = {
        order: '',
        timefix: '',
        category: { id: null, name: 'Select Category' },
        subcategory: { id: null, name: 'Select Subcategory' },
        device: { id: null, deviceName: 'Select Device' },
        user: { id: null, username: 'Select User' },
        detail: '',
        fixdetail: '',
        operator: '',
        status: '',
      }

      // แสดงฟอร์มการซ่อม
      this.showRepairForm = true
    },

    clearSelectedFix() {
      this.selectedFix = null
      this.imageUrls = []
      this.errorMessage = ''
    },

    async handleFixSaved() {
      if (parseInt(this.$store.getters.userId, 10) === 414) {
        await this.fetchFixesheadApprove()
      } else {
        await this.fetchFixes()
      }
      this.showRepairForm = false
    },

    async viewDetails(fix) {
      this.selectedFix = { ...fix }
      this.isLoadingViewDetails = true

      try {
        const [spareList, expense] = await Promise.all([
          this.fetchSpareList(fix.id),
          this.fetchExpense(fix.id),
        ])

        this.spareList = spareList
        this.expense = Array.isArray(expense) ? expense : [expense]

        this.showDetailsModal = true
      } catch (error) {
        console.error('Error loading data', error)
      } finally {
        this.isLoadingViewDetails = false
      }
    },

    onSortChange(field) {
      const isDescending = this.sortField === field && !this.sortDescending

      this.sortField = field
      this.sortDescending = isDescending

      this.filteredFixes.sort((a, b) => {
        const aValue = a[field]
        const bValue = b[field]

        // เปรียบเทียบค่าและกำหนดทิศทางการจัดเรียง
        if (field === 'order') {
          // สำหรับฟิลด์ 'order' ให้เรียงจากมากไปน้อย
          return isDescending ? bValue - aValue : aValue - bValue
        }

        // สำหรับฟิลด์อื่นๆ ให้จัดเรียงตามปกติ
        if (aValue < bValue) return isDescending ? 1 : -1
        if (aValue > bValue) return isDescending ? -1 : 1
        return 0
      })

      this.currentPage = 1 // รีเซ็ตหน้าเป็นหน้าแรกหลังจากการจัดเรียง
    },

    async fetchSpareList(fixId) {
      try {
        const response = await apiAdmin.get(`/sparelistByFixId/${fixId}`) // URL ตัวอย่าง
        return response.data || [] // คืนค่า spareList
      } catch (error) {
        console.error('Error fetching spare list:', error)
        return []
      }
    },

    async fetchExpense(fixId) {
      try {
        const response = await apiAdmin.get(`/expensefixList/${fixId}`) // URL ตัวอย่าง
        return response.data || [] // คืนค่า expense
      } catch (error) {
        console.error('Error fetching expense:', error)
        return []
      }
    },

    async handleRefresh() {
      try {
        this.showDetailsModal = false
        if (parseInt(this.$store.getters.userId, 10) === 414) {
          await this.fetchFixesheadApprove()
          this.fetchCountwaitingApprove()
        } else {
          await this.fetchFixes()
        }
      } catch (error) {
        console.error('Error while refreshing:', error)
      }
    },

    async fetchCountwaitingApprove() {
      try {
        const response = await apiAdmin.get('/Checker/count')
        this.countWaiting = response.data || 0
      } catch (error) {
        console.error('Error fetching count:', error)
        this.countWaiting = 0
      }
    },

  },
}
</script>

<style scoped>
.listdata {
  font-size: x-small;
  margin: 0.5%;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.fix-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}

.fix-table td,
.fix-table th {
  font-size: small;
}

.custom-modal .modal-dialog {
    width: 100vw; /* ทำให้ modal เต็มความกว้าง */
    height: auto; /* ปรับความสูงตามเนื้อหา */
    max-width: none; /* ไม่จำกัดความกว้างสูงสุด */
}

@media (max-width: 768px) {
  .custom-modal .modal-dialog {
    width: 90vw;
  }
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

.custom-modal .modal-content {
  padding: 20px;
  border-radius: 10px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* สีพื้นหลังขุ่น */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* ทำให้ overlay อยู่เหนือโมเดล */
}

.b-spinner {
  color: white;
}

.loading-container {
  text-align: center;
  color: #fff;
}

.button-container {
  display: flex;
  justify-content: flex-start; /* จัดให้ไปที่ซ้ายสุด */
}

.b-btn {
  margin-right: 10px;
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}

@media (max-width: 768px) {
  .custom-modal .modal-dialog {
    width: 90vw;
  }
}

.fix-table thead {
    display: none; /* ซ่อนหัวตาราง */
  }

  @media (max-width: 768px) {
  .fix-table {
    display: block; /* เปลี่ยนตารางให้เป็น block */
    overflow-x: auto; /* เพิ่มแถบเลื่อนแนวนอน */
    white-space: nowrap;
  }
}

.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap; /* เพื่อให้ปุ่มเลื่อนลงมาในกรณีที่พื้นที่ไม่พอ */
}

/* สำหรับมือถือ */
@media (max-width: 360px) {
  .btn-space {
    justify-content: center; /* จัดตำแหน่งปุ่มไปที่กลาง */
  }

  .btn-space b-button {
    flex: 1 1 100%; /* ทำให้ปุ่มเต็มความกว้าง */
    margin-bottom: 0.5rem; /* เว้นระยะห่างระหว่างปุ่ม */
  }
  .listdata {
    font-size: 0.9rem; /* ลดขนาดฟอนต์ให้เหมาะสมกับหน้าจอเล็ก */
  }

  .search-filters input {
    font-size: 14px; /* ปรับขนาดฟอนต์ของ input ให้อ่านง่าย */
    width: 100%; /* ให้ input ใช้พื้นที่เต็มความกว้าง */
    padding: 8px; /* เพิ่มระยะห่างภายใน input */
  }

  .search-filters label {
    font-size: 14px;
  }

  .custom-modal .modal-dialog {
        width: 95vw; /* ปรับความกว้างของ modal สำหรับมือถือ */
  }

  .fix-table td {
        flex-direction: column; /* ทำให้เซลล์แสดงผลในแนวตั้ง */
        padding: 8px; /* ลดระยะห่างในเซลล์ */
  }
}

.blinking {
  animation: blinkSlow 1.5s infinite;
}

@keyframes blinkSlow {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
  100% {
    opacity: 1;
  }
}
</style>
